import React, { Component } from 'react';
import { SelectInput } from 'react-admin';
import request from '../../network/request';

class CompanySelect extends Component {
  state = {
    choices: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    try {
      const response = await request({
        apiService: 'account',
        path: '/admin/company/search',
        method: 'GET',
        urlParams: { page: 0, size: 1000 },
      });
      if (response && response.ok && response.data) {
        const items = response.data.content || [];
        const choices = items.map(company => ({
          id: company.id,
          name: company.uniqName,
        }));
        this.setState({ choices });
      }
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    const { choices } = this.state;
    return <SelectInput {...this.props} choices={choices} />;
  }
}

export default CompanySelect;